export default __webpack_public_path__ + "static/media/link-simple-horizontal.52879fac.svg";